/**
 * Redacts sensitive information from URLs for Sentry error reporting.
 *
 * - Redacts reset-password path tokens
 * - Clears search parameters
 * - Returns "[malformed-url]" if URL parsing fails
 *
 * @param url - The URL string to redact
 * @returns The redacted URL string, or "[malformed-url]" if parsing fails
 */
export function redactUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    if (urlObj.pathname.includes('reset-password')) {
      urlObj.pathname = '/reset-password/:token';
    }
    urlObj.search = '';
    return urlObj.toString();
  } catch (error) {
    return '[malformed-url]';
  }
}
